import React, { Component } from "react";
import * as enums from "../../../../utils/EnumMapping";
import MainTable from "../../../common/table/MainTable";
import NewOutgoingBill from "./NewOutgoingBill";
import OutgoingAggregatePanel from "./OutgoingAggregatePanel";
import * as columns from "./OutgoingBillColumns";

class OutgoingBill extends Component {
  enrich = (data) => {
    data.map((item) => {
      item.rowType = "OUTGOING_BILL";
      item.paymentMethodLabel = enums.getLabel(
        enums.paymentMethods,
        item.paymentMethod
      );
      item.nullableProjectPublicId = item.projectPublicId || "";
      item.currencyLabel = enums.getLabel(enums.currencies, item.currency);
      item.stateLabel = enums.getLabel(enums.states, item.state);
      return item;
    });
    return data;
  };

  getCookies = () => {
    return [
      {
        name: "billNumberPrefix",
        label: "Kimenő számla előtag",
        value: "",
      },
    ];
  };

  render() {
    return (
      <MainTable
        divClassName="outgoingbill"
        tableName="Kimenő számlák"
        newObjectLabel="Új számla hozzáadása"
        path="/api/outgoingbills"
        enrich={this.enrich}
        columns={(refresh) => columns.columns(refresh)}
        dialogContent={(refresh, close) => (
          <NewOutgoingBill refresh={refresh} close={close} />
        )}
        cookieObjects={this.getCookies()}
        needAggregate={true}
        aggregatePanel={(rows) => <OutgoingAggregatePanel rows={rows} />}
        syncInvoices={{ mode: "OUTBOUND" }}
      />
    );
  }
}

export default OutgoingBill;
